export default { sha: '9c8d3abd4b9decc8a072e7a41290bb64cab23948', buildNumber: 'undefined' }
